export default [{
	"row": 0,
	"value": "q"
}, {
	"row": 0,
	"value": "w"
}, {
	"row": 0,
	"value": "e"
}, {
	"row": 0,
	"value": "r"
}, {
	"row": 0,
	"value": "t"
}, {
	"row": 0,
	"value": "y"
}, {
	"row": 0,
	"value": "u"
},  {
	"row": 0,
	"value": "i"
},  {
	"row": 0,
	"value": "o"
},  {
	"row": 0,
	"value": "p"
}, {
	"row": 1,
	"value": "a"
}, {
	"row": 1,
	"value": "s"
}, {
	"row": 1,
	"value": "d"
}, {
	"row": 1,
	"value": "f"
}, {
	"row": 1,
	"value": "g"
}, {
	"row": 1,
	"value": "h"
}, {
	"row": 1,
	"value": "j"
}, {
	"row": 1,
	"value": "k"
}, {
	"row": 1,
	"value": "l"
}, {
	"row": 2,
	"value": "Shift",
}, {
	"row": 2,
	"value": "z"
}, {
	"row": 2,
	"value": "x"
}, {
	"row": 2,
	"value": "c"
}, {
	"row": 2,
	"value": "v"
}, {
	"row": 2,
	"value": "b"
}, {
	"row": 2,
	"value": "n"
}, {
	"row": 2,
	"value": "m"
}, {
	"row": 2,
	"value": "Backspace"
}, {
	"row": 3,
	"value": "Page1",
},  {
	"row": 3,
	"value": ",",
},  {
	"row": 3,
	"value": "Space",
},  {
	"row": 3,
	"value": ".",
},  {
	"row": 3,
	"value": "Enter",
}, {
	"row": 0,
	"value": "1",
	"page": 1
}, {
	"row": 0,
	"value": "2",
	"page": 1
}, {
	"row": 0,
	"value": "3",
	"page": 1
}, {
	"row": 0,
	"value": "4",
	"page": 1
}, {
	"row": 0,
	"value": "5",
	"page": 1
}, {
	"row": 0,
	"value": "6",
	"page": 1
}, {
	"row": 0,
	"value": "7",
	"page": 1
}, {
	"row": 0,
	"value": "8",
	"page": 1
}, {
	"row": 0,
	"value": "9",
	"page": 1
}, {
	"row": 0,
	"value": "0",
	"page": 1
}, {
	"row": 1,
	"value": "!",
	"page": 1
}, {
	"row": 1,
	"value": "@",
	"page": 1
}, {
	"row": 1,
	"value": "#",
	"page": 1
}, {
	"row": 1,
	"value": "$",
	"page": 1
}, {
	"row": 1,
	"value": "%",
	"page": 1
}, {
	"row": 1,
	"value": "^",
	"page": 1
}, {
	"row": 1,
	"value": "&",
	"page": 1
}, {
	"row": 1,
	"value": "*",
	"page": 1
}, {
	"row": 1,
	"value": "(",
	"page": 1
}, {
	"row": 1,
	"value": ")",
	"page": 1
}, {
	"row": 2,
	"value": "-",
	"page": 1
}, {
	"row": 2,
	"value": "_",
	"page": 1
}, {
	"row": 2,
	"value": "=",
	"page": 1
}, {
	"row": 2,
	"value": "+",
	"page": 1
}, {
	"row": 2,
	"value": ";",
	"page": 1
}, {
	"row": 2,
	"value": ":",
	"page": 1
}, {
	"row": 2,
	"value": "'",
	"page": 1
}, {
	"row": 2,
	"value": "\"",
	"page": 1
}, {
	"row": 2,
	"value": "<",
	"page": 1
}, {
	"row": 2,
	"value": ">",
	"page": 1
}, {
	"row": 3,
	"value": "Page0",
	"page": 1
}, {
	"row": 3,
	"value": "/",
	"page": 1
}, {
	"row": 3,
	"value": "?",
	"page": 1
}, {
	"row": 3,
	"value": "[",
	"page": 1
}, {
	"row": 3,
	"value": "]",
	"page": 1
}, {
	"row": 3,
	"value": "{",
	"page": 1
}, {
	"row": 3,
	"value": "}",
	"page": 1
}, {
	"row": 3,
	"value": "|",
	"page": 1
}, {
	"row": 3,
	"value": "\\",
	"page": 1
}, {
	"row": 3,
	"value": "~",
	"page": 1
}];